var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTodoBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 20q-.7 0-1.162-.462Q4 19.075 4 18.375V5.625q0-.7.463-1.162Q4.925 4 5.625 4h12.75q.7 0 1.163.463.462.462.462 1.162v12.75q0 .7-.462 1.163-.463.462-1.163.462Zm0-1h12.75q.25 0 .437-.188.188-.187.188-.437V5.625q0-.25-.188-.437Q18.625 5 18.375 5H5.625q-.25 0-.437.188Q5 5.375 5 5.625v12.75q0 .25.188.437.187.188.437.188Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodoBox);
export default __webpack_public_path__ + "static/media/todo-box.0b42f741d34a05453fb61bbab2a5d3dd.svg";
export { ForwardRef as ReactComponent };